/**
 * スクロールフェードインアニメーション
 * data-fadein属性を持つ要素をIntersectionObserverで監視し、
 * ビューポートに入った時点でフェードインアニメーションを発火する。
 */
(function () {
  'use strict';

  var FADEIN_SELECTOR = '[data-fadein]';
  var VISIBLE_CLASS = 'is-visible';
  var DESIGN_MODE_CLASS = 'is-design-mode';

  // prefers-reduced-motion チェック
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // 要素内のautoplay動画を明示的に再生する
  function playAutoplayVideos(el) {
    var videos = el.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videos.length; i++) {
      var playPromise = videos[i].play();
      if (playPromise !== undefined) {
        playPromise.catch(function (error) {
          console.error('[scroll-fadein] video.play() failed:', error);
        });
      }
    }
  }

  // 全data-fadein要素を即座に表示状態にする
  function showAllImmediately(className) {
    var elements = document.querySelectorAll(FADEIN_SELECTOR);
    for (var i = 0; i < elements.length; i++) {
      elements[i].classList.add(className);
      playAutoplayVideos(elements[i]);
    }
  }

  // IntersectionObserverのコールバック
  function onIntersection(entries, observer) {
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (!entry.isIntersecting) continue;

      var el = entry.target;

      // カスケード順序のCSS変数を設定
      var order = el.getAttribute('data-fadein-order');
      if (order) {
        el.style.setProperty('--fadein-order', order);
      }

      el.classList.add(VISIBLE_CLASS);
      playAutoplayVideos(el);
      observer.unobserve(el);
    }
  }

  // メイン初期化
  function init() {
    // designMode: 全要素を即座に表示
    if (window.Shopify && Shopify.designMode) {
      showAllImmediately(DESIGN_MODE_CLASS);
      return;
    }

    // reduced-motion: 全要素を即座に表示
    if (prefersReducedMotion()) {
      showAllImmediately(VISIBLE_CLASS);
      return;
    }

    var elements = document.querySelectorAll(FADEIN_SELECTOR);
    if (elements.length === 0) return;

    var observer = new IntersectionObserver(onIntersection, {
      rootMargin: '0px 0px -50px 0px'
    });

    for (var i = 0; i < elements.length; i++) {
      if (!elements[i].classList.contains(VISIBLE_CLASS)) {
        observer.observe(elements[i]);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  window.initScrollFadein = init;
})();
